import { useState,useEffect, useCallback } from "react"
import { ArrowDownIcon, ArrowUpIcon, ChartBarIcon, CheckIcon, SunIcon, CalendarDaysIcon, ClockIcon, UserIcon } from '@heroicons/react/20/solid';
import { useContext } from "react";
import { AuthContext } from "../AuthContext";
import { differenceInDays, format, parseISO } from 'date-fns';
import HolidayChart from "../manager/holidaychart";
import AvailabilityGraph from "../manager/holidaygraph";
import { CloseButton } from "@headlessui/react";
import { differenceInCalendarDays } from 'date-fns';
import HolidayCal from "../manager/holidaycal";
import { set } from "lodash";





export default function StaffHoliday() {

    const [holiday, setHoliday] = useState([]);
    const [staff, setStaff] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    const [myHolidays, setMyHolidays] = useState([]);
    const [request, setRequest] = useState(false);
    const [policy, setPolicy] = useState([]);
    const [avail, setAvail] = useState(false);
    const [startTime, setStartTime] = useState('');
    const [finishTime, setFinishTime] = useState('');
    const [success, setSuccess] = useState(null);

    const [userDetails, setUserDetails] = useState([]);
    const [openInput, setOpenInput] = useState(null);
    const [graph, setGraph] = useState(false);

    const user = useContext(AuthContext);
    const token = localStorage.getItem('token');










    const fetchData = useCallback(() => {
      const fetchStaff = async () => {
        try {
          const response = await fetch('https://api.insightos.co.uk/api/staff', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
          });
  
          if (!response.ok) {
            throw new Error('Failed to fetch staff');
          }
  
          const response2 = await fetch('https://api.insightos.co.uk/api/policies', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
          });
  
          if (!response2.ok) {
            throw new Error('Failed to fetch policies');
          }
  
          const data = await response.json();
          const data2 = await response2.json();
          const policyData = data2.data;
  
          setPolicy(policyData);
          
          // Find current user details
          const currentUserData = data.data.find(staffMember => staffMember.id === user.id);
          setCurrentUser(currentUserData);
          
          const filterStaff =
            user.access === 'admin'
              ? data.data
              : data.data.filter((staff) => staff.Role === user.role);
  
          setStaff(filterStaff);
        } catch (error) {
          console.error('Error fetching staff:', error);
        }
      };
  
      fetchStaff();
    }, [token, user.access, user.id, user.role]);
  
    useEffect(() => {
      fetchData();
    }, [fetchData]);




    useEffect(() => {
        const fetchHoliday = async () => {
          try {
            const response = await fetch('https://api.insightos.co.uk/api/holiday', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials : 'include',
            });
    
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    
            const data = await response.json();
            const holidayData = data.data;
            console.log(holidayData);
    
            // Filter holidays to show only current user's holidays
            const userHolidays = holidayData.filter(holiday => holiday.StaffId === user.id);
            setMyHolidays(userHolidays);
            
            // Keep original holiday data for team view if needed
            const filterHoliday = user.access === "admin" 
              ? holidayData 
              : holidayData.filter(holiday => holiday.Role === user.role);

            setHoliday(filterHoliday);
          } catch (error) {
            console.error('Failed to fetch holiday:', error);
          }
        };
    
        fetchHoliday();
      }, [staff, user.id]);




   







    const handleApprove = async (person) => {

        try {
    
          const response = await fetch(`https://api.insightos.co.uk/api/approve/holiday/${person.id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',

            },
            credentials : 'include',

    
            body: JSON.stringify({
              Holiday: 1,
              FromDate: person.FromDate,
              ToDate: person.ToDate,
              Name: person.Name,
              StaffId: person.StaffId,
              Hours : person.Hours,
              DaysOpen : policy[0].DaysOpen,
    
            })
    
          });
    
          if (!response.ok) {
            throw new Error('Failed to approve holiday');
          }
    
          const updatedHoliday = holiday.map(holiday => {
            if (holiday.id === person.id) {
              return { ...holiday, Approved: 1 };
    
            }
    
            return holiday;
    
          });
    
          setHoliday(updatedHoliday);
    
        } catch (error) {
          console.error('Error approving holiday:', error);
        }
    
      };

    
    
    
    
      
    


      const handleHalfDay = async (person) => {

        try {

          const response = await fetch(`https://api.insightos.co.uk/api/approve/halfholiday/${person.id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },

            body: JSON.stringify({
              Holiday: 1,
              FromDate: person.FromDate,
              ToDate: person.ToDate,
              Name: person.Name,
              StaffId: person.StaffId,
              StartTime: startTime,
              FinishTime: finishTime,
              Hours : person.Hours,
            }),
          });

          if (!response.ok) {
            throw new Error('Failed to approve half day holiday');
          }

          setOpenInput(null);
          setSuccess("Half day holiday approved successfully");

          const updatedHoliday = holiday.map(holiday => {
            if (holiday.id === person
              .id) {
              return { ...holiday, Approved: 1 };
            }
            return holiday;

          });

          setHoliday(updatedHoliday);

        } catch (error) {
          console.error('Error approving half day holiday:', error);
        }

      };


      const handleDelete = async (person) => {

        try {

          const response = await fetch(`https://api.insightos.co.uk/api/deleteholiday/${person.id}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials : 'include',

            body: JSON.stringify({
              holiday: person,
            }),


          });

          if (!response.ok) {
            throw new Error('Failed to delete holiday');
          }

          const updatedHoliday = holiday.filter(holiday => holiday.id !== person.id);
          setHoliday(updatedHoliday);

        } catch (error) {

          console.error('Error deleting holiday:', error);

        }

      };







      


     

      

     



    // Helper function to format dates
    const formatDateDisplay = (dateString) => {
      try {
        return format(parseISO(dateString), 'dd/MM/yyyy');
      } catch (error) {
        return dateString;
      }
    };

    // Calculate holiday statistics
    const holidayStats = currentUser ? {
      taken: currentUser.HolidayTaken || 0,
      entitlement: currentUser.HolidayEntitlement || 0,
      remaining: (currentUser.HolidayEntitlement || 0) - (currentUser.HolidayTaken || 0),
      pending: myHolidays.filter(h => h.Approved === 0).length,
      approved: myHolidays.filter(h => h.Approved === 1).length
    } : { taken: 0, entitlement: 0, remaining: 0, pending: 0, approved: 0 };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
          {/* Header Section */}
          <div className="bg-white shadow-sm border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0">
                    <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                      <CalendarDaysIcon className="h-6 w-6 text-white" />
                    </div>
                  </div>
                  <div>
                    <h1 className="text-2xl font-bold text-gray-900">My Holidays</h1>
                    <p className="text-sm text-gray-500">Manage your holiday requests and view your balance</p>
                  </div>
                </div>
                
                <div className="mt-4 sm:mt-0 flex flex-wrap gap-3">
                  <button 
                    onClick={() => setRequest(true)} 
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200"
                  >
                    <SunIcon className="h-5 w-5 mr-2" />
                    New Request
                  </button>
                  
                  {!avail ? (
                    <button 
                      onClick={() => setAvail(true)}
                      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-200"
                    >
                      <ArrowUpIcon className="h-5 w-5 mr-2" />
                      Team Availability
                    </button>
                  ) : (
                    <button 
                      onClick={() => setAvail(false)}
                      className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-lg shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200"
                    >
                      Close Availability
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {/* Holiday Statistics Cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
              <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                      <CalendarDaysIcon className="h-5 w-5 text-blue-600" />
                    </div>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium text-gray-500">Entitlement</p>
                    <p className="text-2xl font-bold text-gray-900">{holidayStats.entitlement}</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center">
                      <CheckIcon className="h-5 w-5 text-red-600" />
                    </div>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium text-gray-500">Taken</p>
                    <p className="text-2xl font-bold text-gray-900">{holidayStats.taken.toFixed(1)}</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
                      <SunIcon className="h-5 w-5 text-green-600" />
                    </div>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium text-gray-500">Remaining</p>
                    <p className="text-2xl font-bold text-gray-900">{holidayStats.remaining.toFixed(1)}</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-yellow-100 rounded-lg flex items-center justify-center">
                      <ClockIcon className="h-5 w-5 text-yellow-600" />
                    </div>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium text-gray-500">Pending</p>
                    <p className="text-2xl font-bold text-gray-900">{holidayStats.pending}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Team Availability Chart */}
            {avail && (
              <div className="mb-8">
                <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
                  <div className="flex items-center mb-4">
                    <ArrowUpIcon className="h-6 w-6 text-green-600 mr-3" />
                    <h3 className="text-lg font-semibold text-gray-900">Team Availability</h3>
                  </div>
                  <HolidayChart />
                </div>
              </div>
            )}

            {/* Request Form */}
            {request && (
              <div className="mb-8">
                <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
                  <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <SunIcon className="h-6 w-6 text-white mr-3" />
                        <h3 className="text-lg font-semibold text-white">Holiday Request Form</h3>
                      </div>
                      <button 
                        onClick={() => setRequest(false)} 
                        className="text-white hover:text-gray-200 transition-colors duration-200"
                      >
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className="p-6">
                    <HolidayCal onTriggerParentEffect={fetchData} holiday={holiday} />
                  </div>
                </div>
              </div>
            )}

            {/* Success Message */}
            {success && (
              <div className="mb-6 rounded-lg bg-green-50 p-4 border border-green-200">
                <div className="flex">
                  <CheckIcon className="h-5 w-5 text-green-400" />
                  <div className="ml-3">
                    <p className="text-sm font-medium text-green-800">{success}</p>
                  </div>
                </div>
              </div>
            )}

            {/* My Holidays Table */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
              <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
                <div className="flex items-center">
                  <UserIcon className="h-6 w-6 text-gray-600 mr-3" />
                  <h3 className="text-lg font-semibold text-gray-900">My Holiday Requests</h3>
                  <span className="ml-3 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    {myHolidays.length} requests
                  </span>
                </div>
              </div>
              
              {/* Desktop Table */}
              <div className="hidden sm:block overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">From Date</th>
                      <th scope="col" className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">To Date</th>
                      <th scope="col" className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Duration</th>
                      <th scope="col" className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Type</th>
                      <th scope="col" className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Reason</th>
                      <th scope="col" className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Status</th>
                      <th scope="col" className="px-6 py-4 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {myHolidays.map(holidayRequest => (
                      <tr key={holidayRequest.id} className="hover:bg-gray-50 transition-colors duration-200">
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium">
                          {formatDateDisplay(holidayRequest.FromDate)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium">
                          {formatDateDisplay(holidayRequest.ToDate)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          <div className="flex items-center">
                            <ClockIcon className="h-4 w-4 text-gray-400 mr-1" />
                            {holidayRequest.Hours} hrs
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                            {holidayRequest.FullDay}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 max-w-xs truncate">
                          {holidayRequest.Notes || 'No reason provided'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {holidayRequest.Approved === 1 ? (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                              <CheckIcon className="h-3 w-3 mr-1" />
                              Approved
                            </span>
                          ) : (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                              <ClockIcon className="h-3 w-3 mr-1" />
                              Pending
                            </span>
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          {holidayRequest.Approved === 0 && (
                            <button 
                              onClick={() => handleDelete(holidayRequest)} 
                              className="inline-flex items-center px-3 py-1.5 border border-red-300 text-xs font-medium rounded-md text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-200"
                            >
                              <svg className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                              Cancel
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile Cards */}
              <div className="sm:hidden space-y-4 p-4">
                {myHolidays.map(holidayRequest => (
                  <div key={holidayRequest.id} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                    <div className="flex justify-between items-start mb-3">
                      <div>
                        <p className="text-sm font-medium text-gray-900">
                          {formatDateDisplay(holidayRequest.FromDate)} - {formatDateDisplay(holidayRequest.ToDate)}
                        </p>
                        <p className="text-xs text-gray-500 mt-1">{holidayRequest.Hours} hours • {holidayRequest.FullDay}</p>
                      </div>
                      <div>
                        {holidayRequest.Approved === 1 ? (
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            <CheckIcon className="h-3 w-3 mr-1" />
                            Approved
                          </span>
                        ) : (
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                            <ClockIcon className="h-3 w-3 mr-1" />
                            Pending
                          </span>
                        )}
                      </div>
                    </div>
                    
                    {holidayRequest.Notes && (
                      <p className="text-sm text-gray-600 mb-3">{holidayRequest.Notes}</p>
                    )}
                    
                    {holidayRequest.Approved === 0 && (
                      <button 
                        onClick={() => handleDelete(holidayRequest)} 
                        className="w-full inline-flex justify-center items-center px-3 py-2 border border-red-300 text-xs font-medium rounded-md text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-200"
                      >
                        <svg className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        Cancel Request
                      </button>
                    )}
                  </div>
                ))}
                
                {myHolidays.length === 0 && (
                  <div className="text-center py-8">
                    <CalendarDaysIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                    <p className="text-gray-500">No holiday requests found</p>
                    <p className="text-sm text-gray-400 mt-1">Click "New Request" to submit your first holiday request</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

    )
}

